<template>
    <div class="product-item" v-if="pointProduct">
        <div class="img-product">
            <img class="img-fluid" :src="`${pictureUrl}${pointProduct.image}`" />
        </div>
        <div class="btn-step">
            <div class="text-btn" @click="clickPointStep()">
               {{pointProduct.button}}
            </div> 
        </div>
        <div class="wrapper-detail">
            <div class="text-header">
                <div class="text">
                    <p>
                        {{pointProduct.title}}
                        <span>{{pointProduct.point}}</span>
                    </p>
                    <img src="@/assets/icon/reward_icon_coin@2x.png">
                </div>
            </div>
            <div class="text-detail">
                <p v-for="(productDetail, k) in pointProduct.description" :key="k">
                    {{productDetail.text}}
                </p>
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import Vue from 'vue';
import ModalMixin from "@/mixin/ModalMixin.js";
export default {
    name: "ProductPointItem",
    props: {
        lbl: Object,
        pointProduct: Object,
        activeTab: String,
    },
    mixins: [ModalMixin],
    data: function() {
        return {
            listProductDetail: [],
            pictureUrl: Vue.bzbsConfig.bzbsBlobUrl + '/config/bioderma/productPointDetail/image/',
        }
    },
    created: function() {
        this.initialPointCollectionStepModal();
    },
    mounted: function(){
        //this.productList();
    },
    methods: {
        // productList: function(){ 
        //     this.listProductDetail = this.pointProduct;
        //     console.log('detail', this.listProductDetail)
        // },
        clickPointStep: function() {
            this.pointCollectionStepModal.show();
        }
    }
}
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";

.product-item{
    padding-bottom: 40px;

    .btn-step{
        width: 150px;
        margin: -20px auto 40px;
        position: relative;

        .text-btn{
            background-color: $dark-blue;
            border-radius: 50px;
            text-align: center;
            color: $white;
            font-size: 1.1rem;
            box-shadow: $box-shadow;
            padding: 7px 0;
        }
    }
    .wrapper-detail{ 
        width: 90%;
        margin: auto;

        .text-header{
            @include header();
            padding-bottom: 15px;

            .text{
                font-size: 1.25rem;

                @include mini-mobile(){
                     font-size: 1.1rem;
                }

                p{
                    display: inline-block;

                    span{
                        color: $pink;
                        font-size: 1.4rem;
                    }
                } 
            }

            img{
                width: 24px;
                display: inline-block;
                border-radius: 50%;
                border: solid 1px $border-gray;
                box-shadow: $box-shadow;
                margin: {
                    top: -5px;
                    left: 8px;
                }
            } 
        }
        .text-detail{
            color: $bright-gray;
            font-size: 1.1rem;

            p{
                line-height: 1;
            }
        }
    }
}
</style>